import { render, staticRenderFns } from "./yxIndex.vue?vue&type=template&id=3ae97c52&scoped=true&"
import script from "./yxIndex.vue?vue&type=script&lang=js&"
export * from "./yxIndex.vue?vue&type=script&lang=js&"
import style0 from "./yxIndex.vue?vue&type=style&index=0&id=3ae97c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae97c52",
  null
  
)

export default component.exports